export default{
  corretor: '',
  Empreendimento: '',
  periodo: ''
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesreportsbroker/salesreportsbroke-form.js